var render, staticRenderFns
import script from "./footer-newsletter-subscription.vue?vue&type=script&lang=js"
export * from "./footer-newsletter-subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d76b0",
  null
  
)

export default component.exports